import { Star } from "lucide-react";
import { Reveal, SectionTag } from "./shared";

const REVIEWS = [
  {
    quote: "Pointed it at my keyboard on turbo and it looked like a sandstorm. Two years of crumbs gone in ten seconds. Absolutely unhinged little machine.",
    name: "Marcus T.",
    role: "Verified buyer — PC builder",
  },
  {
    quote: "I detail cars on weekends. This thing chases water out of mirrors and grilles better than my bulky corded blower. It lives in my glovebox now.",
    name: "Dana R.",
    role: "Verified buyer — car detailer",
  },
  {
    quote: "Bought it as a joke because of the name. Now I use it daily — camera gear, desk, even starting the BBQ. The LED light is weirdly useful too.",
    name: "Jonas K.",
    role: "Verified buyer — photographer",
  },
];

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="border-t border-steel bg-carbon/40">
    <div className="mx-auto max-w-[1600px] px-5 py-24 md:px-10 md:py-36">
      <Reveal>
        <SectionTag index="07" label="Field Reports" />
        <h2 className="mt-6 max-w-4xl font-display text-3xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
          Owners are <span className="text-volt">not okay</span> (in a good way)
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-4 md:mt-20 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={0.08 * i}>
            <blockquote
              data-testid={`review-card-${i}`}
              className="flex h-full flex-col justify-between border border-steel bg-ink p-8 transition-colors duration-300 hover:border-volt md:p-10"
            >
              <div>
                <div className="flex gap-1" aria-label="5 out of 5 stars">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-volt text-volt" />
                  ))}
                </div>
                <p className="mt-6 text-sm leading-relaxed text-foreground/90 md:text-base">“{r.quote}”</p>
              </div>
              <footer className="mt-8 border-t border-steel pt-5">
                <div className="font-display text-xs font-bold uppercase tracking-wider">{r.name}</div>
                <div className="mt-1 font-mono text-[10px] tracking-[0.25em] uppercase text-smoke">{r.role}</div>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
